import { render } from "./Widget.vue?vue&type=template&id=b03d9ff2&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=b03d9ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03d9ff2"]])

export default __exports__